import {
  createSlice
} from '@reduxjs/toolkit';

export const majorList = createSlice({
  name: 'majorList',
  initialState: {
    data: ['beforeFetch']
  },
  reducers: {
    fetchSuccess(state, action) {
      const {
        payload
      } = action;
      state.data = payload;
    },
  },
}).reducer;